import React, { useEffect, useMemo } from 'react'
import { Route, useHistory } from 'react-router-dom'
import { useAuth0 } from 'config/react-auth0-spa'
import LoadingPage from 'pages/Minimal/LoadingPage'
import Authorize from '../Authorize'

// Checks if user is authenticated and otherwise redirects
const PrivateRoute = ({
  component: Component,
  path,
  title,
  restrictAccess,
  sampleImage,
  fadeIn,
  projectRoles,
  ...rest
}) => {
  const { location, push } = useHistory()
  const { loading, loginWithRedirect, isAuthenticated } = useAuth0()

  useEffect(() => {
    // 1.) Normal login
    if (loading || isAuthenticated) {
      return
    }

    // 2.) Catch errors in the URL e.g. from auth0 redirect (to avoid endless loop of redirections)
    const params = new URLSearchParams(location.search)
    const error = params.get('error')
    if (error) {
      console.log('ERROR PRIVATE ROUTE', error)
      const errorDescription = params.get('error_description')
      if (error === 'unauthorized') {
        // user.email is parsed from Error String, see https://manage.auth0.com/dashboard/eu/ventury-analytics/rules/rul_spnXMbcw2m6MovcI
        push({
          pathname: errorDescription.includes('not_verified')
            ? '/signup-successful'
            : '/access-denied',
          state: { email: errorDescription.split(':')[1] },
        })
        return
      }
      push('/error-log')
      return
    }

    // 3.) Redirect if not authenticated
    const fn = async () => {
      await loginWithRedirect({ appState: { targetUrl: path } })
    }
    fn()
  }, [loading, isAuthenticated, loginWithRedirect, path])

  // useMemo => Avoid rerender on change of auth0 state (background syncing)
  return useMemo(() => {
    const render = (props) =>
      isAuthenticated === true ? (
        <Authorize
          redirect
          to="/access-denied"
          restrictAccess={restrictAccess}
          projectRoles={projectRoles}
          title={title}
          sampleImage={sampleImage}
          fadeIn={fadeIn}
        >
          <Component {...props} {...rest} />
        </Authorize>
      ) : (
        <LoadingPage />
      )
    return <Route path={path} render={render} />
  }, [isAuthenticated, restrictAccess, sampleImage, title, projectRoles])
}

export default PrivateRoute
